import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <FaqSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <AboutSection />
        <MediaSection />
        <TopicsSection />
        <RankingSection />
        <CardsSection />
        <AppSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}